export default {
  pickColor (num = null, variant = 'darken-3') {
    var colorNum = 0
    if (num === null) {
      colorNum = Math.floor(Math.random() * 9)
    } else {
      colorNum = num % 9
    }
    var color
    switch (colorNum) {
      case 0: color = 'pink'; break
      case 1: color = 'purple'; break
      case 2: color = 'indigo'; break
      case 3: color = 'light-blue'; break
      case 4: color = 'cyan'; break
      case 5: color = 'teal'; break
      case 6: color = 'green'; break
      case 7: color = 'amber'; break
      case 8: color = 'deep-orange'; break
    }
    return color + ' ' + variant
  }
}
